/* global FB */
import { feathers } from '@/feathers-client';

export default {
  mounted() {
    const _this = this;
    this.$nextTick(() => {
      window.fbAsyncInit = function() {
        FB.init({
          appId: process.env.FB_SDK_APPID,
          xfbml: true,
          version: 'v10.0',
        });
        FB.AppEvents.logPageView();
        _this.FB = FB;
        _this.fbLoaded = true;
      };

      if (window.FB) {
        _this.fbLoaded = true;
      }

      (function(d, s, id) {
        if (d.getElementById(id)) return;

        const js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';

        const fjs = d.getElementsByTagName(s)[0];
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    });
  },
  data() {
    return {
      FB: {},
      fbLoaded: false,
      fb_adAccounts: [],
    };
  },
  methods: {
    async fb_createFbUser(fbUserId, accessToken) {
      const response = await feathers.service('fb-connected-users').create({
        fb_user_id: fbUserId,
        fb_access_token: accessToken,
        fb_user_type_id: "Personal",
      });
      return response;
    },
    async fb_getFbUserAdAccounts() {
      const data = await feathers.service('fb-ad-accounts').find({
        query: { fb_user_type_id: 1 },
      });
      this.fb_adAccounts = data.ad_accounts || [];
    },
    async fb_saveAdAccountsConnected(adAccounts) {
      const mappedAdAccounts = adAccounts.map(({ account_id, name }) => ({ account_id, name }));
      await feathers.service('fb-connected-ad-accounts').create({
        fb_ad_accounts: mappedAdAccounts,
      });
    }
  }
};
